// Validates a GTIN (GS1) number: exact digit length + mod-10 check digit
const isValidGtin = (value, length) => {
  const gtin = value.toString().trim();
  if (!new RegExp(`^\\d{${length}}$`).test(gtin)) return false;
  const digits = gtin.split("").map(Number);
  const checkDigit = digits.pop();
  const sum = digits.reverse().reduce((acc, digit, index) => acc + digit * (index % 2 === 0 ? 3 : 1), 0);
  return (10 - (sum % 10)) % 10 === checkDigit;
};

export const customValidations = (field, tempformError, value, flag, t) => {
  switch (field.validation) {
    //sample funtion
    case "email1":
      console.log(field.validation);
      const regex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
      if (!regex.test(value)) {
        tempformError = "Please provide a valid email Id";
        flag += 1;
      }
      break;
    case "phoneNumber":
      const phoneRegex = new RegExp(`^[1-9]\\d{${(field.maximum ?? 10) - 1}}$`);
      if (!phoneRegex.test(value)) {
        tempformError = `Please provide a valid ${
          field.maximum ?? 10
        }-digit WhatsApp Number`;
        flag += 1;
      }
      break;
    case "numeric":
      if ((field.numericLength ?? 0) === 0) {
        // If lengthCount is 0, any number is allowed
        const numericRegex = /^\d+$/;
        if (!numericRegex.test(value)) {
          tempformError = t("validContent", { label: t(field.label) });
          flag += 1;
        }
      } else if (field.numericLength > 0) {
        // If numericLength is greater than 0, the number must have that specific length
        const numericRegex = new RegExp(`^\\d{${field.numericLength}}$`);
        if (!numericRegex.test(value)) {
          tempformError = `Please enter a number that ${field.numericLength} length`;
          flag += 1;
        }
      }
      break;
    case "gtin13":
      if (!isValidGtin(value, 13)) {
        tempformError = "Please provide a valid 13-digit GS1 barcode (GTIN-13)";
        flag += 1;
      }
      break;
    case "gtin14":
      if (!isValidGtin(value, 14)) {
        tempformError = "Please provide a valid 14-digit GS1 carton barcode (GTIN-14)";
        flag += 1;
      }
      break;
    default:
      break;
  }
  return { flag, tempformError };
};
